import { useState } from "react";

import { EditIcon } from "@dotnet/telematics-design-system";

import { useAuth } from "../../../../../context/Auth/AuthProvider";
import {
  USER_PERMISSIONS,
  USER_ROLES_RAW_DATA
} from "../../../../../roles/types/enums";
import {
  COMPANIES_ACTIONS,
  RenderConditionOptions
} from "../../../../../shared";

const useCompaniesInlineActions = () => {
  const { getAccessStatus } = useAuth();

  const [rowData, setRowData] = useState<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const openDialog = (data: any) => {
    setRowData(data);
    setIsOpen(true);
  };

  const closeDialog = () => {
    setRowData(null);
    setIsOpen(false);
  };

  const handleEditCompanyClick = (data: any) => {
    openDialog(data);
  };

  const inlineRenderConditions = ({ data, user }: RenderConditionOptions) => {
    const supportRole = user?.role === USER_ROLES_RAW_DATA.TeltonikaSupport;

    const userCompany = user?.company?.id;
    const selectedCompany = user?.selectedCompany?.id;
    const clientCompany = user?.selectedRootCompany?.id;
    const rowId = data?.id;

    const selectedUserRootCompany = userCompany === clientCompany;
    const isRootCompanySelected = selectedCompany === clientCompany;
    const rootCompanyRow = rowId === clientCompany;

    const singleRootCompanyRow =
      !selectedUserRootCompany && isRootCompanySelected && rootCompanyRow;

    if (
      getAccessStatus(USER_PERMISSIONS.EditCompanies) &&
      supportRole &&
      !getAccessStatus(USER_PERMISSIONS.ManageAllUsers)
    ) {
      return selectedUserRootCompany || singleRootCompanyRow || false;
    }

    return (
      getAccessStatus(USER_PERMISSIONS.EditCompanies) &&
      (!supportRole || getAccessStatus(USER_PERMISSIONS.ManageAllUsers))
    );
  };

  const inlineActions = [
    {
      title: COMPANIES_ACTIONS.EditCompany,
      icon: <EditIcon />,
      clickAction: handleEditCompanyClick,

      renderConditions: ({ data, user }: RenderConditionOptions) =>
        inlineRenderConditions({ data, user })
    }
  ];

  return {
    inlineActions,
    rowData,
    isOpen,
    closeDialog
  };
};

export default useCompaniesInlineActions;
